import React from "react";
import CommonGridSection from "../../component/common/CommonGridSection";

const benefitsData = [
  {
    title: "20k+ Tons of Waste Converted to Energy",
    desc: "Contributing to a cleaner environment and resource optimization.",
    icon: "/images/plantIcon1.png",
  },
  {
    title: "40% Carbon Footprint Reduction",
    desc: "Helping industries and households lower emissions.",
    icon: "/images/plantIcon1.png",
  },
  {
    title: "Cost Savings on Energy Consumption",
    desc: "Reducing electricity and fuel costs through renewable alternatives.",
    icon: "/images/plantIcon1.png",
  },
  {
    title: "Supporting India’s Clean Energy & Net-Zero Goals",
    desc: "Advancing SATAT goals through circular economy and ESG-focused operations.",
    icon: "/images/plantIcon1.png",
  },
];

const BenefitsSection = () => {
  return (
    <CommonGridSection
      subHeader="Our Benefits"
      mainHeader="Environmental and Economic Impact"
      items={benefitsData}
      backgroundColor="bg-[#1C233A]" // Dark Blue
      cardColor="bg-[#B7DB83]" // Light Green
      textColor="text-white"
      gridCol="grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-4"
    />
  );
};

export default BenefitsSection;
